module.exports = __webpack_public_path__ + "static/media/squash.c82886f9.svg";